export default __webpack_public_path__ + "static/char-s-54-ja-7b4ee7f5516f1f53848188dc432fbe1f.png";